import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";

export const SCRIPT_ID = "stn-embedcode-loader";

export const getSendToNewsScriptUrl = (videoAdCode) =>
  videoAdCode ? `https://embed.sendtonews.com/player3/embedcode.js?fk=${videoAdCode}` : "";

export const loadSendToNewsScript = (videoAdCode, onLoaded, onError) => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (!videoAdCode) return;

  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript) {
    if (onLoaded && existingScript.dataset.loaded === "true") {
      onLoaded();
    }
    return;
  }

  try {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.async = true;
    script.type = "text/javascript";
    script.src = getSendToNewsScriptUrl(videoAdCode);

    script.onload = () => {
      script.dataset.loaded = "true";
      if (typeof onLoaded === "function") {
        onLoaded();
      }
    };

    script.onerror = (err) => {
      console.warn("Failed to load SendToNews embed script:", err);
      if (typeof onError === "function") {
        onError(err);
      }
    };

    document.body.appendChild(script);
  } catch (err) {
    console.warn("Error injecting SendToNews script:", err);
    if (typeof onError === "function") {
      onError(err);
    }
  }
};

export const SendToNewsEmbed = ({ videoAdCode: propVideoAdCode, className, style }) => {
  const reduxVideoAdCode = useSelector((state) =>
    get(state, ["qt", "data", "videoAdCode"])
  );

  const videoAdCode = propVideoAdCode || reduxVideoAdCode;

  useEffect(() => {
    loadSendToNewsScript(videoAdCode);
  }, [videoAdCode]);

  if (!videoAdCode) return null;

  return (
    <div
      data-stn-player={videoAdCode}
      className={className}
      style={{ width: "100%", height: "100%", ...style }}
    />
  );
};

SendToNewsEmbed.propTypes = {
  videoAdCode: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default SendToNewsEmbed;
